import Loadable from './Loadable';

const PATH_PREFIX = '/business/:companyID';

export default [
  {
    name: 'business.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
    exact: true,
    component: Loadable(import('../ui/apps/business/dashboard')),
  },
  {
    name: 'business.profile',
    path: `${PATH_PREFIX}/profile`,
    exact: true,
    component: Loadable(import('../ui/apps/business/profile')),
  },
  {
    name: 'business.commercial_practice',
    path: `${PATH_PREFIX}/commercial_practice`,
    exact: true,
    component: Loadable(import('../ui/apps/business/commercialPractice')),
  },
  {
    name: 'business.market_coverage',
    path: `${PATH_PREFIX}/market_coverage`,
    exact: true,
    component: Loadable(import('../ui/apps/business/marketCoverage')),
  },
  {
    name: 'business.shipping_method.list',
    path: `${PATH_PREFIX}/shipping_methods`,
    exact: true,
    component: Loadable(import('../ui/apps/business/shippingMethod/list')),
  },
  {
    name: 'business.shipping_method.detail',
    path: `${PATH_PREFIX}/shipping_method/:docID/detail`,
    exact: true,
    component: Loadable(import('../ui/apps/business/shippingMethod/detail')),
  },
  {
    name: 'business.payment_method.list',
    path: `${PATH_PREFIX}/payment_methods`,
    exact: true,
    component: Loadable(import('../ui/apps/business/paymentMethod/list')),
  },
  {
    name: 'business.payment_method.detail',
    path: `${PATH_PREFIX}/payment_method/:docID/detail`,
    exact: true,
    component: Loadable(import('../ui/apps/business/paymentMethod/detail')),
  },
  {
    name: 'business.keyword.classifications',
    path: `${PATH_PREFIX}/classifications`,
    exact: true,
    component: Loadable(import('../ui/apps/business/classification')),
  },
  {
    name: 'business.keyword.brands',
    path: `${PATH_PREFIX}/brands`,
    exact: true,
    component: Loadable(import('../ui/apps/business/brand')),
  },
  {
    name: 'business.keyword.tags',
    path: `${PATH_PREFIX}/tags`,
    exact: true,
    component: Loadable(import('../ui/apps/business/tag')),
  },
  {
    name: 'business.follow.explore',
    path: `${PATH_PREFIX}/follow/explore`,
    exact: true,
    component: Loadable(import('../ui/apps/business/follow/explore')),
  },
  {
    name: 'business.follow.following',
    path: `${PATH_PREFIX}/follow/followings`,
    exact: true,
    component: Loadable(import('../ui/apps/business/follow/followings')),
  },
  {
    name: 'business.follow.followers',
    path: `${PATH_PREFIX}/follow/followers`,
    exact: true,
    component: Loadable(import('../ui/apps/business/follow/followers')),
  },
  {
    name: 'business.subdirectory.tags',
    path: `${PATH_PREFIX}/subdirectory/tags`,
    exact: true,
    component: Loadable(import('../ui/apps/business/subdirectory/tag')),
  },
  {
    name: 'business.contacts',
    path: `${PATH_PREFIX}/contacts`,
    exact: true,
    component: Loadable(import('../ui/apps/business/emailLink')),
  },
  {
    name: 'business.branch',
    path: `${PATH_PREFIX}/branches`,
    exact: true,
    component: Loadable(import('../ui/apps/business/branch')),
  },
  {
    name: 'business.logo',
    path: `${PATH_PREFIX}/logo`,
    exact: true,
    component: Loadable(import('../ui/apps/business/logo')),
  },
  {
    name: 'business.banner',
    path: `${PATH_PREFIX}/banner`,
    exact: true,
    component: Loadable(import('../ui/apps/business/banner/list')),
  },
  {
    name: 'business.banner.detail',
    path: `${PATH_PREFIX}/banner/:docID`,
    exact: true,
    component: Loadable(import('../ui/apps/business/banner/detail')),
  },
  {
    name: 'business.advertisement',
    path: `${PATH_PREFIX}/advertisement`,
    exact: true,
    component: Loadable(import('../ui/apps/business/advertisement')),
  },
  {
    name: 'business.catalogue',
    path: `${PATH_PREFIX}/catalogue`,
    exact: true,
    component: Loadable(import('../ui/apps/business/catalogue')),
  },
  {
    name: 'business.departments',
    path: `${PATH_PREFIX}/departments`,
    exact: true,
    component: Loadable(import('../ui/apps/business/department/list')),
  },
  {
    name: 'business.department',
    path: `${PATH_PREFIX}/teams/departments/:docID`,
    exact: true,
    component: Loadable(import('../ui/apps/business/department/detail')),
  },
  {
    name: 'business.employees',
    path: `${PATH_PREFIX}/teams/employees`,
    exact: true,
    component: Loadable(import('../ui/apps/business/employee/list')),
  },
  {
    name: 'business.employee',
    path: `${PATH_PREFIX}/teams/employees/:docID`,
    exact: true,
    component: Loadable(import('../ui/apps/business/employee/detail')),
  },
  {
    name: 'business.page.main_page',
    path: `${PATH_PREFIX}/page/main_page`,
    exact: true,
    component: Loadable(import('../ui/apps/business/pages/mainPage')),
  },
  {
    name: 'business.page.faq',
    path: `${PATH_PREFIX}/page/faq`,
    exact: true,
    component: Loadable(import('../ui/apps/business/pages/faq')),
  },
  {
    name: 'business.setting',
    path: `${PATH_PREFIX}/setting`,
    exact: true,
    component: Loadable(import('../ui/apps/business/setting')),
  },
];
